export default {"src":"/_next/static/media/carrying-boat.mono.b6fea770.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};